export const LoanProductsSkeleton = () => {
  return (
    <div className="pr-[40px] pl-[10px] w-full animate-pulse">
      {/* Header */}
      <div className="flex my-[10px] items-center justify-between">
        <div className="h-[28px] w-[200px] bg-gray-300 rounded-md"></div>
        <div className="h-[40px] w-[180px] bg-gray-300 rounded-full"></div>
      </div>

      {/* Summary Cards */}
      <div className="flex items-center gap-[20px] mb-4">
        {[1, 2, 3].map((_, i) => (
          <div
            key={i}
            className="h-[70px] w-[220px] bg-gray-200 rounded-[10px]"
          ></div>
        ))}
      </div>

      {/* Top Bar Buttons */}
      <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px]">
        <div className="h-[40px] w-[117px] bg-gray-200 rounded-[10px]"></div>
        <div className="h-[40px] w-[117px] bg-gray-200 rounded-[10px]"></div>
        <div className="h-[40px] w-[127px] bg-gray-200 rounded-[10px]"></div>
        <div className="h-[40px] w-[50%] bg-gray-200 rounded-md"></div>
        <div className="h-[20px] w-[80px] bg-gray-200 rounded-md"></div>
        <div className="h-[40px] w-[120px] bg-gray-200 rounded-full"></div>
      </div>

      {/* Table Header */}
      <div className="h-[44px] px-[10px] w-full bg-[#F3F3F3] mb-[10px] flex items-center">
        {[5, 14, 15, 15, 14, 14, 14, 14].map((w, i) => (
          <div key={i} className={`w-[${w}%]`}>
            <div className="h-[14px] w-full bg-gray-300 rounded-md"></div>
          </div>
        ))}
      </div>

      {/* Skeleton rows */}
      {[...Array(12)].map((_, i) => (
        <div
          key={i}
          className="h-[40px] px-[10px] w-full bg-white mb-[10px] flex items-center"
        >
          {[5, 14, 15, 15, 14, 14, 14, 14].map((w, j) => (
            <div key={j} className={`w-[${w}%]`}>
              <div className="h-[14px] w-[100%] bg-gray-200 rounded-md"></div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
